import React from "react";
import PropTypes from "prop-types";
import { Media } from "components/Media";
import cn from "classnames";
import css from "./Banner.module.scss";
import Button from "components/Button";


class Banner extends React.Component {
  static propTypes = {
    version: PropTypes.oneOf([
      "big-quotation-small-speech-bubble",
      "small-quotation-big-speech-bubble"
    ]),
    backgroundVideo: Media && Media.propTypes.video,
    backgroundImage: Media && Media.propTypes.image,
    backgroundImageMobile: Media && Media.propTypes.imageMobile,
    backgroundImageAlt: PropTypes.string,
    bubbleColor: PropTypes.oneOf(["yellow", "white", "gray"]),
    bubbleText: PropTypes.shape({
      line1: PropTypes.string,
      line2: PropTypes.string
    }),
    quotationColor: PropTypes.oneOf(["white", "gray"]),
    quotationText: PropTypes.shape({
      line1: PropTypes.string,
      line2: PropTypes.string
    }),
    button: PropTypes.shape({
      linkText: PropTypes.string,
      url: PropTypes.string
    })
  };

  static defaultProps = {

  };

  render() {
    const {version,
      backgroundVideo,
      backgroundImage,
      backgroundImageMobile,
      backgroundImageAlt,
      bubbleColor,
      bubbleText,
      quotationColor,
      quotationText,
      button } = this.props;


    return (
      <div className={cn(css.banner, version)}>
      {/* BE: Mobile image recommended size is 768x1200px */}
      <Media
        image={backgroundImage}
        imageMobile={backgroundImageMobile}
        video={backgroundVideo}
        alt={backgroundImageAlt ? backgroundImageAlt : ''}
      />
      <div className={css.banner__quotation}>
        {bubbleText && 
          <div className={cn(css.banner__bubble, bubbleColor)}>
            <div className={css.banner__bubbleContainer}>
              <div className={css.banner__bubbleBorderTop} />
              <div className={css.banner__bubbleBorderBottom} />

              {version === "small-quotation-big-speech-bubble" && quotationText && 
                <div className={css.banner__quotationTextContainer}>
                <div className={cn(css.banner__quotationText, quotationColor)}>
                  {quotationText.line1 && <div>{quotationText.line1}</div>}
                  {quotationText.line2 && <div>{quotationText.line2}</div>}
                </div>
                </div>
              }
              <div className={css.banner__bubbleText}>
                {bubbleText.line1 && <div>{bubbleText.line1}</div>}
                {bubbleText.line2 && <div>{bubbleText.line2}</div>}
              </div>
            </div>
          </div>
        }
        {quotationText &&  version === "big-quotation-small-speech-bubble" &&
          <div className={css.banner__quotationTextContainer}>
            <div className={cn(css.banner__quotationText, quotationColor)}>
              {quotationText.line1 && <div>{quotationText.line1}</div>}
              {quotationText.line2 && <div>{quotationText.line2}</div>}
            </div>
          </div>
        }
      </div>
      <div className={css.banner__linkContainer}>
        <div>
          {button && button.url && button.linkText ? (
            <Button tertiary href={button.url}>
              {button.linkText}
            </Button>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
    );
  }
}

export default Banner;



// WEBPACK FOOTER //
// ./src/components/Banner/Banner.jsx